var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{staticStyle:{"background":"#ececec"},attrs:{"selectIndex":"1-1"}}),_c('MobileNavBar',{attrs:{"currentActive":1}}),_c('Contest'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }